import type { TExamQuestionsForResultSet } from "#/services/rest/gwt/exam-results/descriptive/exam-question-result-set.types";
import styles from "./answer.module.scss";
import AskVideo from "./AskVideo";
import CompleteAnswer from "./CompleteAnswer";
import Rate from "./Rate";

type Props = {
  answer: TExamQuestionsForResultSet["answer"];
  answerRate?: TExamQuestionsForResultSet["answerRate"];
  answerAuthorInfo?: TExamQuestionsForResultSet["answerAuthorInfo"];
  mediaHasRequested?: TExamQuestionsForResultSet["mediaHasRequested"];
  mediaRequestCount?: TExamQuestionsForResultSet["mediaRequestCount"];
  answerId: TExamQuestionsForResultSet["answerId"];
  choiceId1: TExamQuestionsForResultSet["choiceId1"];
  choiceId2: TExamQuestionsForResultSet["choiceId2"];
  choiceId3: TExamQuestionsForResultSet["choiceId3"];
  choiceId4: TExamQuestionsForResultSet["choiceId4"];
  difficultyLevelId: TExamQuestionsForResultSet["difficultyLevelId"];
  mediaId?: TExamQuestionsForResultSet["mediaId"];
  mediaLink?: TExamQuestionsForResultSet["mediaLink"];
  id: TExamQuestionsForResultSet["id"];
};
const Answer = (props: Props) => {
  const {
    answer,
    answerAuthorInfo,
    answerRate,
    mediaHasRequested,
    mediaRequestCount,
    answerId,
    choiceId1,
    choiceId2,
    choiceId3,
    choiceId4,
    difficultyLevelId,
    mediaId,
    mediaLink,
    id,
  } = props;

  const generateAnswerIndex = (answerId: string, choiceIds: string[]) => {
    return choiceIds.findIndex((item) => item === answerId) + 1;
  };

  return (
    <div className={styles["answer-container"]}>
      <AskVideo
        id={id}
        answerAuthorInfo={answerAuthorInfo}
        mediaHasRequested={mediaHasRequested}
        mediaRequestCount={mediaRequestCount}
        mediaId={mediaId}
        mediaLink={mediaLink}
      />

      <CompleteAnswer
        difficultyLevelId={difficultyLevelId}
        answer={answer}
        answerIndex={generateAnswerIndex(answerId, [
          choiceId1,
          choiceId2,
          choiceId3,
          choiceId4,
        ])}
      />

      <Rate answerRate={answerRate} id={id} />
    </div>
  );
};
export default Answer;
